import { render, staticRenderFns } from "./praise-follow.vue?vue&type=template&id=cec54c2a&scoped=true&"
import script from "./praise-follow.vue?vue&type=script&lang=js&"
export * from "./praise-follow.vue?vue&type=script&lang=js&"
import style0 from "./praise-follow.vue?vue&type=style&index=0&id=cec54c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec54c2a",
  null
  
)

export default component.exports